module.exports = __webpack_public_path__ + "img/165.fa48aaf7.jpg";